import ProjectEditorDetail from "../editor/Detail";
import Global from "components/common/Global";
import CryptoJS from 'crypto-js';
import { useSearchParams } from "react-router";
import GuideLayout from "../editor/guide/Guide";
import GuidesLayout from "../editor/guide/Guides";

/** 编辑器库需要用到 */
window.CryptoJS = CryptoJS ;

export default function ProjectEditor(){
    // const params = useParams() ;
    // const [searchParams] = useSearchParams();
    // const isGuide = !searchParams.get('id') ;
    // if(isGuide){
        return (
            <Global>
                <GuidesLayout>
                    <ProjectEditorDetail isMockupsSrc={true}/>
                </GuidesLayout>
            </Global>
        )
    // }

    // return (
    //     <Global>
    //         <ProjectEditorDetail isMockupsSrc={true}/>
    //     </Global>
    // )
}